import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { portfolioItems } from '../mock';
import { BeforeAfterSlider } from './BeforeAfterSlider';
import { Reveal, Stagger, StaggerItem } from './motion/Reveal';

export const BeforeAfterSection = ({ category }) => {
  const { t } = useLanguage();
  const items = portfolioItems
    .filter((p) => p.category === category && p.beforeAfter)
    .flatMap((p) => (Array.isArray(p.beforeAfter) ? p.beforeAfter : [p.beforeAfter]).map((pair, i) => ({ ...p, pair, key: `${p.id}-${i}` })));
  if (items.length === 0) return null;
  const portrait = items.filter((i) => (i.pair.ratio || 1.5) < 1).length > items.length / 2;

  return (
    <div className="mb-16" data-testid="before-after-section">
      <Reveal>
        <h2 className="heading-4 text-[white] mb-3">
          {t({ sl: 'Prej / Potem', en: 'Before / After', it: 'Prima / Dopo' })}
        </h2>
        <p className="body-medium text-[#b0b0b0] mb-8 max-w-2xl">
          {t({
            sl: 'Povlecite drsnik in primerjajte stanje pred našo izvedbo in po njej.',
            en: 'Drag the slider to compare the result before and after our work.',
            it: 'Trascina il cursore per confrontare il risultato prima e dopo il nostro lavoro.'
          })}
        </p>
      </Reveal>
      <Stagger className={`grid md:gap-8 ${portrait ? 'grid-cols-2 lg:grid-cols-3 gap-4' : 'grid-cols-1 md:grid-cols-2 gap-6'}`} stagger={0.12}>
        {items.map((item) => (
          <StaggerItem key={item.key}>
            <BeforeAfterSlider
              before={item.pair.before}
              after={item.pair.after}
              alt={t(item.title)}
              className="w-full"
              style={{ aspectRatio: item.pair.aspect || '3 / 2' }}
              testId={`before-after-${item.key}`}
            />
            <p className="text-white font-semibold mt-3 md:mt-4 text-sm md:text-base">{t(item.title)}</p>
            <p className="text-[#b0b0b0] text-xs md:text-base hidden sm:block">{t(item.description)}</p>
          </StaggerItem>
        ))}
      </Stagger>
    </div>
  );
};
